<template>
    <base-modal @close="$emit('close')">
        <div
            slot="header"
            class="h3"
        >
            Importer dossiers Excel
        </div>

        <div slot="body">
            <div class="row">
                <div class="col-12">
                    <base-input-file v-model="file">
                        Fichier d'import au format .xlsx (format et colonnes à respecter)
                    </base-input-file>
                </div>
            </div>
        </div>

        <div slot="footer">
            <button
                v-btn-loading="importingDossiers"
                class="btn btn-success"
                :disabled="file === null"
                @click="importationDossiersExcel"
            >
                Importer
            </button>
        </div>
    </base-modal>
</template>

<script>
    import BaseModal from "../templates/BaseModal"
    import BaseLoader from "../templates/BaseLoader"
    import BaseInputFile from "../templates/BaseInputFile"

    export default {
        name: "ImportationDossiersExcelModal",
        components: {BaseInputFile, BaseModal},

        mixins: [],

        data: function () {
            return {
                file: null,
                params: {
                },
                importingDossiers: false,
            }
        },

        methods: {
            /**
             * Importe les dossiers depuis le fichier excel
             */
            importationDossiersExcel: function () {
                this.importingDossiers = true

                let formData = new FormData()

                formData.append('import_file', this.file)

                const headers = {'Content-Type': 'multipart/form-data'}

                axios.post('/api/dossiers/import-excel', formData, {headers})
                    .then(this.successImport)
                    .catch(this.errorImport)
                    .finally(() => this.importingDossiers = false)
            },

            /**
             * Callback de succès d'import du fichier
             */
            successImport: function () {
                this.$notify('success', "L'import du fichier se fera d'ici quelques minutes, un mail vous sera envoyé après sa validation.")
                this.$emit('close')
            },

            /**
             * Callback d'échec d'import du fichier
             */
            errorImport: function (error) {
                let errorMessage = error.response.data.message
                    ? error.response.data.message
                    : "Une erreur est survenue lors de l'importation du fichier."

                this.$notify('danger', errorMessage, 20000)
            }
        }
    }
</script>
